module.exports = __webpack_public_path__ + "img/wzrmgy.4f0c01c7.jpg";